import React from "react";

import { Upload } from "antd";

import { Icon, IconButton, LazyLoadImage, Spin, Typography } from "components";

const UploadImage = ({
  alt = "",
  className = "",
  id = "",
  imageSuccess,
  imageUrl,
  label,
  large = false,
  name,
  openFileDialogOnClick = true,
  uploading = false,
  beforeUpload = () => {},
  onChange = () => {},
  onDelete,
  profile,
}) => (
  <>
    {!profile ? (
      <div className="image-upload">
        <Upload
          action=""
          beforeUpload={beforeUpload}
          className={`${imageSuccess || imageUrl ? "uploaded" : ""} ${large ? "large" : ""} ${className}`}
          id={id}
          listType="picture-card"
          openFileDialogOnClick={openFileDialogOnClick}
          name={name}
          showUploadList={false}
          onChange={onChange}
        >
          {imageUrl ? (
            <>
              {onDelete && (
                <div className="trash">
                  <IconButton type="secondary" shape="circle" iconName="tabler/trash" size="small" onClick={onDelete} />
                </div>
              )}
              <LazyLoadImage alt={alt} style={{ width: "100%" }} src={imageUrl} />
            </>
          ) : uploading ? (
            <Spin />
          ) : (
            <>
              <Icon iconName="klim/plus" size="xl" />
              <Typography variant="paragraph-m">{label}</Typography>
            </>
          )}
        </Upload>
      </div>
    ) : (
      <Upload
        action=""
        beforeUpload={beforeUpload}
        className={`${className} avatar-edit`}
        id={id}
        openFileDialogOnClick={openFileDialogOnClick}
        name={name}
        showUploadList={false}
        onChange={onChange}
      >
        <Icon iconName="klim/edit-element" className="icon" size={40} />
      </Upload>
    )}
  </>
);

export { UploadImage };
